export { default } from './TabBarScene';
